import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  setArchiveModalOpen,
  setRefetchTasks,
  setSelectedRowIds,
  setSingleTaskArchive,
} from "app/store/tasks/slice/taskSlice";
import { showSuccessToast, showErrorToast } from "utils/toast";
import { useArchiveTasksMutation } from "app/store/tasks/api/taskApi";

const useArchiveModal = (setRowSelection) => {
  const [processing, setProcessing] = useState(false);
  const [archiveTasks] = useArchiveTasksMutation();
  const { archiveModalOpen, selectedRowIds } = useSelector(
    (state) => state.task
  );
  const dispatch = useDispatch();

  if (!archiveModalOpen && processing) {
    setProcessing(false);
  }

  const closeArchiveModal = () => {
    processing && setProcessing(false);
    dispatch(setArchiveModalOpen(false));
    dispatch(setSingleTaskArchive(false));
    dispatch(setSelectedRowIds([]));
    setRowSelection?.({});
  };

  const onConfirm = async () => {
    try {
      setProcessing(true);
      const { message } = await archiveTasks(selectedRowIds).unwrap();

      if (message) {
        dispatch(setRefetchTasks(true));
        showSuccessToast(message);

        setRowSelection?.({});
      }
    } catch (error) {
      showErrorToast(error?.message || "An error occured, please try later.");
    }
    dispatch(setSelectedRowIds([]));
    closeArchiveModal();
  };

  return {
    processing,
    archiveModalOpen,
    selectedRowIds,
    closeArchiveModal,
    setProcessing,
    onConfirm,
  };
};

export default useArchiveModal;
